import BaseInputControl from "./BaseInputControl";
import type { HandleInputChange } from "./types";

type NumberInputProps = {
    name: string;
    value?: string | number;
    placeholder?: string;
    onChange: HandleInputChange;
};

const NumberInput = ({ name, value, placeholder, onChange }: NumberInputProps) => {
    return (
        <BaseInputControl
            type="number"
            name={name}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
        />
    );
};

export default NumberInput;
